// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"265":"d8bdf80b","472":"d9ca63ea","488":"5d648ff5","680":"5b8ae82e","805":"4f2f57b6","888":"4821fc2a"}[chunkId] + ".chunk.js";
};